import swal from 'sweetalert';
import { sessionDisconnect, sessionUnSubscribe } from './SocketService';
import { disconnectSocketConnection } from './CommonApi';



export const fileSchemaSweetAlert = (response)  => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = 
    `<div style="margin:20px;height: 300px; overflow-y: auto; ">
        <table border="1" style="width:100%; border-collapse: collapse,font-family: 'Roboto', sans-serif;">
            <thead style="position: sticky;top: 0;background-color: #f2f2f2; z-index: 1;">
                <tr>
                <th style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">Instance Path</th>
                <th style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">Required Type</th>
                <th style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">Error Message</th>
                <th style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">Data</th>
                </tr>
            </thead>
            <tbody>
                ${response?.errors.map(item => `
                <tr>
                    <td style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">${item.instancePath}</td>
                    <td style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">${item?.requiredType}</td>
                    <td style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">${item.errorMessage}</td>
                    <td style="padding: 12px 16px;text-align: left;border-bottom: 1px solid #ddd;">${JSON.stringify(item.data)}</td>
                </tr>
                `).join('')}
            </tbody>
        </table>
    </div>`;
    swal({
        title: 'Oops!',
        text: response.message,
        content:wrapper,
        icon: "error",
        dangerMode: true,
        className: "swal-full",
    }).then(function() {
        const swalElement = document.querySelector('.swal-modal');
        if (swalElement) {
            swalElement.classList.remove('swal-back');
        }
    });

    
        

};


export const oopsSweetAlert = (response)  => {
    swal({
        title: 'Oops!',
        text: response.message,
        icon: "error",
        dangerMode: true,
    });
};

export const errorSweetAlert = (response)  => {
    swal({
        title: 'Error',
        text: response.message,
        icon: "error",
        dangerMode: true,
    });
};

export const handleEndSessionAlert = (serialNumber,row_id)  => {
   
    swal({
        title: "End Session",
        text: 'Are you sure you want to end this session?',
        icon: "warning",
        buttons: ["No", "Yes"],
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
    }).then(async willDelete => {
        if (willDelete) {
            let param = {"room_id":serialNumber,"row_id":row_id,"session_status":"disconnect"}
            await disconnectSocketConnection(param);
            window.opener.sessionStorage.removeItem('connection');
            sessionStorage.removeItem('connection');
            sessionUnSubscribe(serialNumber);
            sessionDisconnect('disconnect');
            window.open('', '_self').close()
        }
    });
};

export const handleSessionInterruptAlert = ()  => {
    swal({
        title: "Session Interrupted",
        text: 'Remote Connection session is interrupted due to refresh. Please try to connect it again.',
        icon: "error",
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
    })
    .then(willDelete => {
        if (willDelete) {
            window.opener.sessionStorage.removeItem('connection');
            sessionStorage.removeItem('connection');
            window.open('', '_self').close()
        }
    });
};

export const handleSessionCommunicatingAlert =  (serialNumber,row_id)  => {
    swal({
        title: "Error",
        text: "There is some error while communicating with socket device. Please try again.",
        icon: "error",
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
    }).then(async willDelete => {
        if (willDelete) {
            let param = {"room_id":serialNumber,"row_id":row_id,"session_status":"disconnect"}
            await disconnectSocketConnection(param);
            window.opener.sessionStorage.removeItem('connection');
            sessionStorage.removeItem('connection');
            sessionUnSubscribe(serialNumber);
            sessionDisconnect('disconnect');
            window.open('', '_self').close()
        }
    });
};



export const handleUserLeft = ()  => {
    swal({
        title: "Error",
        text: "User left the session on the app side. Please close the window.",
        icon: "error",
        closeOnClickOutside:false,
        closeOnEsc: false,
        allowOutsideClick: false,
    }).then(async willDelete => {
        if (willDelete) {
            window.open('', '_self').close()
        }
    });
};